<template>
  <slot />
</template>

<script setup lang="ts">
import 'swiper/css'
</script>
